















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { makeToast } from '@/modules/budget-request/components/js/some-functions';
import { calcProgn } from '@/modules/budget-request/components/js/budgetCalcProgn';
import { formLst } from '@/modules/budget-request/components/js/budgetFormsLst';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import {doNum, getRowKey, MSG_REQ_TH, MSG_SMS, trMsg} from "@/modules/budget/bip/bip-types";

@Component({name: 'c-guelevel-modal'})
export default class CBudgetSumCalcGuLevelModal extends Vue {
    private showModal = false;
    private add_need = false;

    private dataArr: any[] = [];
    private collapseAll = true;
    private titleYear: string = '';

    private progress = 0;

    private totalSum = 0;

    private showEvent(params: any) {
        if (params.hasOwnProperty('add_need')) {
            this.add_need = params.add_need;
        }
        this.loadData(params);
        this.showModal = true;
    }

    private async loadData(params: any) {
        this.dataArr = [];
        this.progress = 45;
        this.totalSum = 0;
        this.titleYear = `${params.year}`;
        let result = null;
        try {
            result = await fetch(encodeURI(`/api-py/get-budget-calc-gulvl/${JSON.stringify(params)}`));
            this.progress = 75;
            if (result.status === 200) {
                result = await result.json();
                result.sort((a: any, b: any) => (a.gu >= b.gu) ? 1 : -1);

                // const dataArr: any[] = [];
                // for (const el of result) {
                //     if (el.value && calcProgn(new Map([[el.form, el]]), params.spf)!==null) {
                //         if (!dataArr.length || dataArr[dataArr.length - 1].gu !== el.gu) {
                //             this.sumVal(dataArr);
                //             dataArr.push({gu: el.gu, guName: el.guName, formLst: []});
                //         }
                //         const url = this.getUrl(params, el);
                //         dataArr[dataArr.length - 1].formLst.push({form: el.form, bipCode: el.bip_code, bipName: el.bip_name, value: Math.round(el.value), url: url});
                //     }
                // }
                // this.sumVal(dataArr);

                const dataArr = this.guGroup(result, params);
                this.dataArr = await this.mergeDataArrays(dataArr, params);
                console.log(dataArr, this.dataArr)

            }  else {
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        } finally {
            this.progress = 100;
        }
    }

    private guGroup(arr: any[], params: any, field: string = 'value') {
        const dataArr: any[] = [];

        for (const el of arr) {
            if (el.value && calcProgn(new Map([[el.form, el]]), params.spf)!==null) {
                if (!dataArr.length || dataArr[dataArr.length - 1].gu !== el.gu) {
                    dataArr.push({gu: el.gu, guName: el.guName, formLst: []});
                }
                const url = this.getUrl(params, el);
                const item = {
                    form: el.form,
                    bipCode: el.bip_code,
                    bipName: el.bip_name,
                    url: url
                }
                this.$set(item, field, Math.round(el.value));

                dataArr[dataArr.length - 1].formLst.push(item);
            }
        }
        return dataArr;
    }

    // Метод для объединения массивов
    private async mergeDataArrays(currentData: any[], params: any): Promise<any[]> {
        let prevData = null;

        try {
            if (this.add_need) {
                const params_prev = JSON.parse(JSON.stringify(params));
                this.$set(params_prev, 'variant', params_prev.prev_variant);

                prevData = await fetch(encodeURI(`/api-py/get-budget-calc-gulvl/${JSON.stringify(params_prev)}`));
                prevData = await prevData.json();
            }
        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_load'), (error as Error).toString());
            return this.combineDataArrays(currentData, []);
        }

        if (!prevData || prevData.length === 0) {
            return this.combineDataArrays(currentData, []);
        }

        // Обрабатываем prevData так же, как currentData в основном методе
        prevData.sort((a: any, b: any) => (a.gu >= b.gu) ? 1 : -1);
        const processedPrevData = this.guGroup(prevData, params, 'prev');

        // Объединяем currentData с обработанными предыдущими данными
        return this.combineDataArrays(currentData, processedPrevData);
    }

    // Вспомогательный метод для объединения уже обработанных данных
    private combineDataArrays(currentData: any[], prevData: any[]): any[] {
        const mergedMap = new Map();

        // Сначала добавляем предыдущие данные
        for (const prevItem of prevData) {
            mergedMap.set(prevItem.gu, {
                gu: prevItem.gu,
                guName: prevItem.guName,
                formLst: [...prevItem.formLst]
            });
        }

        // Затем добавляем/обновляем текущими данными
        for (const currentItem of currentData) {
            if (mergedMap.has(currentItem.gu)) {
                // Если GU уже существует - объединяем formLst
                const existingItem = mergedMap.get(currentItem.gu);
                existingItem.formLst = this.mergeFormLists(currentItem.formLst, existingItem.formLst);
            } else {
                // Если GU не существует - добавляем новый элемент
                mergedMap.set(currentItem.gu, {
                    gu: currentItem.gu,
                    guName: currentItem.guName,
                    formLst: [...currentItem.formLst]
                });
            }
        }
        const result = Array.from(mergedMap.values());

        // Постобработка: добавляем недостающие поля и вычисляем add_need
        return this.postProcessData(result, (this.add_need ? 'add_need' : 'value'));
    }

    // Метод для объединения списков форм
    private mergeFormLists(currentForms: any[], prevForms: any[]): any[] {
        if (!prevForms || prevForms.length === 0) {
            return currentForms;
        }

        const formMap = new Map();

        // Сначала добавляем формы из предыдущих данных
        for (const prevForm of prevForms) {
            const key = `${prevForm.form}-${prevForm.bipCode}`;
            formMap.set(key, { ...prevForm });
        }

        // Затем добавляем/обновляем формами из текущих данных
        for (const currentForm of currentForms) {
            const key = `${currentForm.form}-${currentForm.bipCode}`;

            if (formMap.has(key)) {
                // Если форма уже существует - объединяем
                const existingForm = formMap.get(key);
                formMap.set(key, {
                    // Приоритет у текущих данных для текстовых полей
                    ...existingForm,
                    bipName: currentForm.bipName || existingForm.bipName,
                    bipCode: currentForm.bipCode || existingForm.bipCode,
                    url: currentForm.url || existingForm.url,
                    // Числовые поля суммируем
                    value: currentForm.value,
                    add_need: doNum(currentForm.value) - doNum(existingForm.prev)
                });
            } else {
                // Если формы нет - добавляем новую
                formMap.set(key, { ...currentForm });
            }
        }

        return Array.from(formMap.values());
    }

    // Метод для постобработки данных
    private postProcessData(data: any[], field: string = 'value'): any[] {
        this.totalSum = 0;

        return data.map(item => {
            let sum = 0;

            // Обрабатываем каждую форму в formLst
            const processedFormLst = item.formLst.map((form: any) => {
                // Гарантируем наличие value = 0 если нет значения
                const value = form.value || 0;

                // Гарантируем наличие prev = 0 если нет поля
                const prev = form.prev || 0;

                // Вычисляем add_need = value - prev
                const add_need = value - prev;

                sum += (field === 'value' ? value : add_need);
                this.totalSum += (field === 'value' ? value : add_need);

                // Возвращаем форму со всеми обязательными полями
                return {
                    ...form,
                    value: value,
                    prev: prev,
                    add_need: add_need
                };
            });

            return {
                ...item,
                formLst: processedFormLst,
                sum: sum
            };
        });
    }

    private sumVal(dataArr: any[], field: string = 'value') {
        if (dataArr.length) {
            if (!dataArr[dataArr.length -1].formLst.length) {
                dataArr.splice(dataArr.length -1, 1);
                return;
             }
            let sum = 0;
            for (const f of dataArr[dataArr.length -1].formLst) {
                sum += doNum(f[field]);
            }
            dataArr[dataArr.length - 1].sum = Math.round(sum);
            this.totalSum += Math.round(sum);
            dataArr[dataArr.length - 1].collapse = this.collapseAll;
        }
    }

    private clkCollapse(indx: number | null) {
        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataArr) {
                el.collapse = this.collapseAll;
            }
            return;
        }
        this.dataArr[indx].collapse = !this.dataArr[indx].collapse;
    }


    private getUrl(obj: any, el: any): string | null {
        if (el.value_source_link) {
            return `#/${el.value_source_link}`;
        }
        if (el.form!==null) {
            let href: string | null = null;
            for (let i=0; i<formLst.length; i++) {
                if (formLst[i].code === el.form) {
                    href = formLst[i].href;
                    break;
                }
            }
            if (href === null) { href = `/form${el.form}`; }
            const params = `#${href}/${obj.curYear}/${obj.year}/${obj.dataType}/${el.gr}/${obj.abp}/${obj.prg}/${obj.ppr}/${el.gu}/${obj.variant}/${obj.spf}/no/gu/true/end`;
            return params;
        } else if (el.bip_code) {
            const params = `#/bip/bip-card?${encodeURI(`bip_code=${el.bip_code}&variant=${obj.variant}`)}`;
            return params;
        }
        return null;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: {
                val0: this.getBudgetText('sum_calc_abp.gulvl_modal.title.val0'), // Детализация
                val1: this.getBudgetText('sum_calc_abp.gulvl_modal.title.val1') // г.
            },
            gu: this.getBudgetText('sum_calc_gu.gu'), // ГУ
            form_bip: this.getBudgetText('sum_calc_gu.form_bip'), // Форма/БИП
            sum: this.getBudgetText('sum_calc_abp.gulvl_modal.sum'), // СУММА ТЫС. ТЕҢГЕ
            add_need: trMsg(this, MSG_REQ_TH + 'add_need'), // Доп. потребность
            total: this.getBudgetText('sum_calc_abp.gulvl_modal.total'), // Итого
        }
        return obj;
    }
}
